import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import efg from "../../Assets/Cert/efg.png";
import "./style.css";
import { useAuth } from "../../Context/UserContext/index.tsx";

const Certificate = () => {
  const { username, canName, courseId, batchNo,serialNo } = useAuth()
  const today = new Date();
const courseDate = today.toLocaleDateString('en-GB'); // Outputs in DD/MM/YYYY format

  const downloadPDF = () => {
    const input = document.getElementById("certificate");

    html2canvas(input, {
      scale: 2,
      useCORS: true
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("certificate.pdf");
    });
  };

  return (
    <div>
      <div className="certificate-container" id="certificate">
        <div className="certificate-header">
          <div className="logo">
            <img src={efg} alt="cert" width={80} />
          </div>
          <div className="company-name">EFG TRAINING SERVICES PRIVATE LTD</div>
        </div>
          <div className="serial">Serial no: {serialNo}</div>

        <div className="certificate-body">
          <h1>Certificate</h1>
          <p className="completion">of Completion</p>
          <p className="learning">Asynchronous Learning</p>
          <h2 className="course-title-cert">Forklift Refresher Training</h2>

          <p className="presented">This certificate is proudly presented to</p>
          <h2 className="student-name">{canName}   ({username})</h2>

          <p className="cert-details bottom-confirmation">
            This certifies that the above-named individual has successfully completed the <strong>Forklift Operator Refresher Training</strong> through <strong>Asynchronous Learning</strong> and is deemed <strong>Competent</strong>.
          </p>


          <div className="footer">
            <div className="left">Course date: {courseDate}</div>

            <div className="center-image">
              <img src={require("../../Assets/Cert/stamp.jpeg")} alt="stamp" className="stamp-img" />
            </div>

            <div className="right">
              <img src={require("../../Assets/Cert/sign.jpeg")} alt="signature" className="signature-img" />
              <br />
              <strong>Rosli Bin Pitchay</strong>
              <br />
              Director / Principal
            </div>
          </div>

        </div>




        <div className="company-footer">
          EFG Training services Private Ltd | No: 3, Soon Lee Street, 01-16,
          Pioneer Junction, Singapore – 627606
          <br />
          Email: <a href="mailto:admin@efg.com.sg">admin@efg.com.sg</a> | Phone:
          +65 6334 7872 / 91814091
        </div>
      </div>

      <button onClick={downloadPDF} className="download-button">
        Download as PDF
      </button>
    </div>
  );
};

export default Certificate;
